import AhaButton from '@/components/UI/Button.vue'
import AhaPage from '@/components/UI/Page.vue'
import AhaContent from '@/components/UI/Content.vue'
import AhaHeader from '@/components/UI/Header.vue'
import AhaFooter from '@/components/UI/Footer.vue'
import AhaLogo from '@/components/UI/Logo.vue'

import AhaFormatter from '@mindthegapstudio/stpancras-storybook-app/src/presenter/components/UI/Formatter.vue'
import AhaSvg from '@mindthegapstudio/stpancras-storybook-app/src/presenter/components/UI/Svg.vue'
import AhaSpinner from '@mindthegapstudio/stpancras-storybook-app/src/presenter/components/UI/Spinner.vue'

// components suppose to be in storybook
// but have to clone here because backstage is using vue 3
// instead of vue 2
import AhaSvgContainer from '@/components/UI/SvgContainer.vue'

export default (app: any) => {
  app.component('AhaButton', AhaButton)
  app.component('AhaPage', AhaPage)
  app.component('AhaContent', AhaContent)
  app.component('AhaHeader', AhaHeader)
  app.component('AhaFooter', AhaFooter)
  app.component('AhaFormatter', AhaFormatter)
  app.component('AhaSvg', AhaSvg)
  app.component('AhaSvgContainer', AhaSvgContainer)
  app.component('AhaLogo', AhaLogo)
  app.component('AhaSpinner', AhaSpinner)
}
